document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".swiper").forEach((swiper) => {
    swiperConfig = {
      slidesPerView: 1,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      loop: swiper.dataset.loop === "true" ? true : false,
      loopAdditionalSlides: 8,
      sensitivity: 0.5,
      spaceBetween: Math.max(parseInt(swiper.dataset.spaceBetween), 0),
      navigation: {
        nextEl: `.swiper-navigation[data-id="${swiper.dataset.id}"] .swiper-arrow-next`,
        prevEl: `.swiper-navigation[data-id="${swiper.dataset.id}"] .swiper-arrow-prev`,
      },
      pagination: {
        el: `.swiper-pagination[data-id="${swiper.dataset.id}"]`,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: Math.max(
            parseInt(swiper.dataset.slidesPerView) - 1,
            1
          ),
        },
        1024: {
          slidesPerView: Math.max(parseInt(swiper.dataset.slidesPerView), 1),
        },
      },
    };

    if (swiper.dataset.thumbsSwiper) {
      let thumbsSwiperElement = document.querySelector(
        `.swiper[data-id="${swiper.dataset.thumbsSwiper}"]`
      );

      let thumbsSwiper = new Swiper(thumbsSwiperElement, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: 4,
          },
        },
      });

      swiperConfig.thumbs = {
        swiper: thumbsSwiper,
      };
    }

    if (swiper.dataset.autoplay && parseInt(swiper.dataset.autoplay) > 0)
      swiperConfig.autoplay = {
        delay: parseInt(swiper.dataset.autoplay) * 1000,
      };

    if (swiper.dataset.disabledBreakpoint) {
      Object.keys(swiperConfig.breakpoints).forEach(function (breakpoint) {
        if (breakpoint >= parseInt(swiper.dataset.disabledBreakpoint)) {
          swiperConfig.breakpoints[breakpoint].enabled = false;
        }
      });
    }

    // console.log(swiper.dataset.id, swiperConfig);

    new Swiper(swiper, swiperConfig);
  });
});
